import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AppShell, Navbar, Header, Footer, Aside, Text, MediaQuery, Burger, useMantineTheme } from "@mantine/core";
import MainNavbar from "./main/MainNavbar";
import DashboardNavbar from "./dashboard/DashboardNavbar";
import DashboardHeader from "./dashboard/DashboardHeader";

export default function DashboardLayout({ children }) {
  const { pathname } = useLocation();
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  //   opened && setOpened(false);
  // }, [pathname]);

  function handleClose() {
    setOpened(false);
  }

  return (
    <AppShell
      styles={{
        main: {
          background: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0],
          paddingTop: 76,
        },
      }}
      padding={0}
      navbarOffsetBreakpoint="sm"
      navbar={<DashboardNavbar opened={opened} toggleOpened={() => setOpened((o) => !o)} close={handleClose} />}
      header={<DashboardHeader opened={opened} toggleOpened={() => setOpened((o) => !o)} close={handleClose} />}
    >
      {children || <Outlet />}
    </AppShell>
  );
}
